import { Icon as GBIcon } from '@gitbook/icons';
import { type IconDefinition, icons } from '@gitbook/icons/icons';

import '@gitbook/icons/style.css';

import { useCallback } from 'react';

import {
    GenericPicker,
    type GenericPickerProps,
    type GenericPickerRenderInfo,
} from './GenericPicker';

export interface IconPickerProps extends Pick<GenericPickerProps<IconDefinition>, 'header'> {
    /**
     * Callback when an icon is selected.
     */
    onPick: (icon: string) => void;

    /**
     * Optional query to filter the icons.
     * If a query is passed, a callback onChangeQuery should be passed to update the query.
     */
    query?: string;

    /**
     * Callback when the query changes.
     */
    onChangeQuery?: (query: string) => void;

    /**
     * Optional color to apply to the icons.
     */
    color?: string;
}

function getKey(icon: IconDefinition) {
    return icon.icon;
}

const textKeys = ['label', 'search'];

/**
 * Component to pick an icon from a list of icons.
 */
export function IconPicker(props: IconPickerProps) {
    const renderItem = useCallback(
        (icon: IconDefinition): GenericPickerRenderInfo => {
            return {
                label: icon.label,
                icon: <GBIcon icon={icon.icon} style={{ backgroundColor: props.color }} />,
            };
        },
        [props.color]
    );
    return (
        <GenericPicker<IconDefinition>
            listId="icons"
            title="Icons"
            items={icons}
            query={props.query}
            onChangeQuery={props.onChangeQuery}
            getKey={getKey}
            onPick={(icon) => props.onPick(icon.icon)}
            renderItem={renderItem}
            textKeys={textKeys}
            header={props.header}
        />
    );
}
